/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import { routeTo } from "router";
import styles from "./InlineTag.module.css";

interface SandboxMetadataEditorProps {
  label: string;
  user?: boolean;
  openLinkNewTab?: boolean
}

export const InlineTag = ({ label, user, openLinkNewTab }: SandboxMetadataEditorProps) => {
  if (openLinkNewTab)
    return <Link to={routeTo.search(label)} onClick={(e) => { e.stopPropagation() }} target="_blank" rel="noopener noreferrer" className={["iui-anchor", user ? styles.user : ""].join(" ")}>{label}</Link>
  else
    return (
      <Link to={routeTo.search(label)} onClick={(e) => { e.stopPropagation() }} className={["iui-anchor", user ? styles.user : ""].join(" ")}>{label}</Link>
    );
};
